import { Component, ElementRef, Input, OnInit, Output, OnChanges, ViewChild, EventEmitter, SimpleChanges } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatMenuTrigger } from '@angular/material/menu';
import { CompanygetxlsxreportParams } from '../../api/models/companygetxlsxreport-params';
import { LoaderService } from '../../_services/loader.service';
import { BaseRequestService } from '../../_services/base.service';
import { CompanyService } from '../../api/services/company.service';
import { MyToastrService } from '../../_services/toastr.service';
import { CommonService } from '../../_services/common.services';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
declare let require: any;

@Component({
  selector: 'app-sa-table',
  templateUrl: './s-table.component.html',
  styleUrls: ['./s-table.component.scss']
})

export class STableComponent implements OnInit, OnChanges {
  @Input() value: any;
  colFilters: any = [];
  colfilter: any = {};
  showUpper = true;
  colFilterQuery: any;
  columns!: Array<any>;
  colHash: any = {};
  displayedColumns!: Array<any>;
  dataSource!: MatTableDataSource<any>;
  @ViewChild('MTABLEDIV', { static: false })
  tableDiv!: ElementRef;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort!: MatSort;
  @ViewChild('filterMenuTrigger', { static: false })
  filterMenuTrigger!: MatMenuTrigger;
  @ViewChild('listMenuTrigger', { static: false })
  listMenuTrigger!: MatMenuTrigger;
  @ViewChild('exportMenuTrigger', { static: false })
  exportMenuTrigger!: MatMenuTrigger;
  @Input() title: any;
  @Input() tableId: any
  @Input() dataList: any;
  @Input() columnsList: any;
  @Input() hyperLinkList: any;
  @Input() query: any;
  @Input() fieldMap: any;
  @Input() existKey: any;
  @Input() customCols: any;
  @Input() showHeaderUpperCase: any;
  @Input() itemPerPage: any;
  @Input() defaultSort: any;
  @Input() isFilterTable = false;
  @Input() filterSource: any;
  @Input() filterSubSource: any;
  @Input() filterKey: any;
  @Input() filterSubKey: any;
  @Input() pageSize = 5;
  @Input() tableOptions: any = { showColFilter: true, refreshData: true };
  @Output() colfilterUpdate = new EventEmitter();
  @Output() hyperlinkCallback = new EventEmitter();
  @Output() refreshCallback = new EventEmitter();
  @Output() actionCallback = new EventEmitter();

  currentUser: any = {};
  customColFilter = new FormControl();
  filteredValues: any = {};
  filterForm: FormGroup;
  linkColumn: any = '';
  formControls: any = {};
  selectedColumn: any = '';
  selectValue: any = '';
  sessionData: any;

  /*customCols=[
    { col: 'isCompliant', htmlCols: { true: ''}}
  ]*/

  private searchedColName: any;

  constructor(private loaderService: LoaderService, private toast: MyToastrService,
    private commonService: CommonService, private formBuilder: FormBuilder,
    private baseService: BaseRequestService, private companyService: CompanyService, 
    private aS: AuthenticationService) {
      this.currentUser = this.aS.currentUser
    }

  columnFilter(val: any, col: any): void {
    this.searchedColName = col;
    this.colfilterUpdate.next({ value: val, col });
    this.colFilters.push({ key: col, name: col, value: val });
  }
  removeFilter(filter: any): void {
    this.colFilters.forEach((obj: { key: string | number; }, index: any) => {
      if (filter.key === obj.key) { this.colfilter[obj.key] = ''; this.colFilters.splice(index, 1); }
    });
    this.formControls[filter.key].setValue('');
    this.removedValueFilter();
    this.colfilterUpdate.emit({ value: '', col: filter.key });
  }

  isTextCenterCol(col: string): boolean {
    if (!this.customCols) { return false; }
    const filter = this.customCols.filter((x: any) => x.col === col);
    if (filter.length) {
      return (filter[0].isCenter);
    }
    return false;
  }

  isExistCustomCols(col: string): boolean {
    if (!this.customCols) { return false; }
    const filter = this.customCols.filter((x: any) => x.col === col);
    return filter.length;
  }
  ngAfterViewInit(): void {
    this.getAllTableSettings();
  }
  ngOnInit(): void {
    // this.IsChecked = true;
    if (this.isFilterTable) {
      this.filterKey = (this.filterKey) ? this.filterKey : this.filterSource[0].value;
      this.filterSubKey = 'Non Compliant';
      const data = this.filterSource.filter((x: any) => x.value === this.filterKey)[0].data;
      this.initiateTable(data);
      // setTimeout(() => { this.updateSubFilterTable({ value: this.filterSubKey }); });
    } else {
      setTimeout(() => this.initiateTable(this.dataList), 500 );
    }

    // Initialize your data source with your full data array
    setTimeout(() => this.dataSource.data = this.dataList, 500 );

    // Create the filter form with form controls for each column
    if(this.displayedColumns && this.displayedColumns.length > 0) {
      this.displayedColumns.forEach((column) => {
        this.formControls[column] = new FormControl('');
      });
    }
    this.filterForm = this.formBuilder.group(this.formControls);
  }

  eventChange(event: any) {
    this.selectedColumn = event.value;
    console.log(event.value);
  }

  removedValueFilter(): void {
    let filteredData = this.dataList.slice();
    for (const column of this.columnsList) {
      const filterValue = this.formControls[column].value.trim().toLowerCase();
      if (column !== this.selectedColumn && filterValue) {
        // Filter the data for the selected column
        filteredData = filteredData.filter((item: any) =>
          item[column].toString().toLowerCase().includes(filterValue)
        );
      }
    }
    this.dataSource.data = filteredData;
  }

  applyMultipleFilters() {
    let filteredData = this.dataList.slice();
    // Loop through all selected columns and apply the filters
    for (const column of this.columnsList) {
      const filterValue = this.formControls[column].value.trim().toLowerCase();
  
      if (column !== this.selectedColumn && filterValue) {
        // Filter the data for the selected column
        filteredData = filteredData.filter((item: any) =>
          item[column].toString().toLowerCase().includes(filterValue)
        );
      }
    }
  
    // Apply the final filter for the currently selected column
    const selectedFilterValue = this.formControls[this.selectedColumn].value.trim().toLowerCase();
    if (this.selectedColumn && selectedFilterValue) {
      filteredData = filteredData.filter((item: any) =>
        item[this.selectedColumn].toString().toLowerCase().includes(selectedFilterValue)
      );
    }
  
    // Update the MatTableDataSource with the filtered data
    this.dataSource.data = filteredData;
    this.colFilters.push({ key: this.selectedColumn, name: this.selectedColumn, value: this.formControls[this.selectedColumn].value.trim().toLowerCase() });
  }

  clearFilter(): void {
    this.dataSource.data = this.dataList.slice();
    // Reset the form control values to empty strings for each column
    for (const column of this.columnsList) {
      this.formControls[column].setValue('');
    }
    this.colFilters = [];
  }

  createColumnLink(col: any): void {
    this.columns.map((ele: any) => {
      if(col === ele.columnDef) {
        ele.isHyperLink = true;
      } else {
        ele.isHyperLink = false;
      }
    });
    this.toast.sToast('success', `${col} column is created as a link`);
  }
  getAllTableSettings(): void {
    let params: any = {};
    params = {
      tableId: this.title,
      reconId: this.tableOptions.reconId,
      userId: this.currentUser.email
    }
    const q: any = JSON.stringify(params);
    this.baseService.doRequest('/api/savetablesettings', 'get', null, {q: q}).subscribe((result: any) => {
      // let result: any = require('../../../assets/json/tablesettings.json');
      if(result.status === true) {
        let col: any;
        if(result.data && result.data.length > 0) {
          if(this.title === result.data[0].tableId) {
            this.sessionData = result.data[result.data.length-1];
            try {
              col = (result.data[0].columnRepr)
                ? JSON.parse(result.data[0].columnRepr) : this.tableOptions.columns;
            } catch (e) {
              e = null;
            }
            this.columns = col.columns;
            this.columnsList = col.columnsList;
            this.hyperLinkList = col.hyperLinkList ;
            if(this.columns && this.columns.length > 0) {
              this.displayedColumns = [];
              this.columns.filter((e) => { if(e.isvisible) { this.displayedColumns.push(e.header) }})
              console.log(this.displayedColumns);
            }
          }
          if (result.data[0].settings.pageSize !== this.tableOptions.pageSize) {
            // setTimeout(() => this.RefreshTableData(), 2000);
          }
          this.tableOptions.pageSize = result.data[0].settings.pageSize;
        } else {
          console.log('Table has no Data..!')
        }
      } else {
        this.toast.sToast('error', result.message);
      }
    });
  }

  saveSettings() {
    let params: any = {};
    let columnRep: any = {};
    columnRep = {
      columnsList: this.columnsList,
      columns: this.columns,
      hyperLinkList: this.hyperLinkList
    }
    params = {
      "tableId": this.tableId,
      "reportName": this.tableOptions.reportName,
      "reconId": this.tableOptions.reconId,
      "columnRepr": JSON.stringify(columnRep),
      "refreshInterval": 0,
      "userId": this.currentUser.email,
      "settings": {
        "gFilter": [],
        "sortOptions": {
          "active": "",
          "direction": ""     
        },
        "pageSize": this.pageSize   
      }
    }
    const method = (this.sessionData && this.sessionData._id) ? 'put' : 'post';
    if (this.sessionData && this.sessionData._id) { params._id = this.sessionData._id; }
    this.baseService.doRequest(`/api/savetablesettings/`, method, params).subscribe((res: any) => {
      if (res.status === true) {
        this.toast.sToast('success', 'Successfully updated!');
      } else {
        this.toast.sToast('error', res.message);
      }
    });
  }

  initiateTable(dataList: any, col?: any): void {
    const cols = dataList
      // tslint:disable-next-line:no-shadowed-variable
      .reduce((cols: any, row: {}) => {
        return [...cols, ...Object.keys(row)];
      }, [])
      // tslint:disable-next-line:no-shadowed-variable
      .reduce((cols: string | any[], column: any) => {
        return cols.includes(column)
          ? cols
          : [...cols, column];
      }, []);
    // Describe the columns for <mat-table>.
    if (this.columns == undefined) {
      this.columns = cols.map((column: string | number) => {
        return {
          columnDef: column,
          header: column,
          cell: (element: any) =>  `${element[column]}`
        };
      });
      this.columns.forEach(col => {
        if (col.isvisible == undefined) {
          col.isvisible = true;
        }
      });
    } 
    if(this.hyperLinkList !== undefined || this.hyperLinkList && this.hyperLinkList.length > 0) {
      // ! CHECK MAIN COLUMN INCLUDES IN LINK COLUMN 
      this.columns.forEach((col: any) => {
        col.isHyperLink = this.hyperLinkList.includes(col.header);
      });
    }

    if (this.displayedColumns == undefined) {
      this.displayedColumns = (this.columnsList && this.columnsList.length)
        ? this.columnsList.slice()
        : this.columns.map(c => c.columnDef);
    }
    if (this.tableOptions.showAction) {
      this.displayedColumns.push('action');
    }
    this.dataSource = new MatTableDataSource<any>(dataList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataList = dataList;
  }

  hyperLink(links: any): void {
    links && links.length > 0 ? this.hyperLinkList = links : this.hyperLinkList; 
  }

  applyFilter(filterValue: any): void {
    const fValue = filterValue.target.value;
    if (this.dataSource) {
      this.dataSource.filter = fValue.trim().toLowerCase();
    }
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  isBool(cell: any): boolean {
    return (cell === 'true' || cell === '');
  }

  hyperLinkCall(row: any, col?: any): any {
    delete row.highlighted;
    delete row.hovered;
    const event = { row, col };
    this.hyperlinkCallback.emit(event);
  }

  getProperty(object: any, propertyName: any): any {
    let parts: any[];
    let property: string;
    parts = propertyName.split('.');
    const length = parts.length;
    let i: number;
    property = object;
    for (i = 0; i < length; i++) {
      // @ts-ignore
      property = (property[parts[i]]) ? property[parts[i]] : ''; // @ts-ignore
      if (property[parts[i]] === 0) { property = property[parts[i]]; }
    }
    return property;
  }

  updateTable($event: any): void {
    this.dataList = undefined;
    this.filterKey = $event.value;
    const dataList = this.filterSource.filter((x: any) => x.value === this.filterKey);
    this.dataSource.data = dataList[0].data.slice();
  }

  // updateSubFilterTable($event: any): void {
  //   this.dataList = undefined;
  //   this.filterSubKey = $event.value;
  //   const dataList = this.filterSource.filter((x: any) => x.value === this.filterKey);
  //   const subDataList = ($event.value === '*')
  //     ? dataList[0].data.slice()
  //     : dataList[0].data.filter((x: any) => (x.filterc === this.filterSubKey));
  //   if (this.dataSource) { this.dataSource.data = subDataList.slice(); }
  // }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.value = changes.value.currentValue;
    }
    if (this.value || this.value === '') {
      if (this.dataSource) {
        this.dataSource.filter = this.value.trim().toLowerCase();
        if (this.dataSource.paginator) {
          this.dataSource.paginator.firstPage();
        }
      }
    }
    if (changes.filterSubKey) {
      // this.updateSubFilterTable({ value: changes.filterSubKey.currentValue });
    }
  }
  refreshTableData(): void {
    this.refreshCallback.emit();
  }

  downloadAsXls(type: string): void {
    const dateStr = new Date().toLocaleDateString().replace(/\//g, '_') + '_'
      + new Date().toLocaleTimeString().replace(/\:/g, '_');
    let xlsxParam: CompanygetxlsxreportParams;
    xlsxParam = { query: '', classname: 'Compliance', fieldmap: [], filename: 'Compliance_' + dateStr };
    xlsxParam.fieldmap = this.fieldMap;
    this.loaderService.display(true, 'Preparing xlsx file...');
    let query: any = {};
    query = Object.assign({}, this.query);
    if (this.isFilterTable && this.filterKey) { // Global filter
      query.query.bool.must.push({ exists: { field: `benchmarks.${this.filterKey}` } });
    }
    if (this.colFilterQuery && this.colFilterQuery.length && type !== 'full') { // Multi Column filter
      query.query.bool.filter = [];
      this.colFilterQuery.forEach((obj: any) => {
        if (obj.bool.should[0].match) {
          query.query.bool.must.push(obj);
        } else {
          query.query.bool.filter.push(obj);
        }
      });
    }
    xlsxParam.query = JSON.stringify(query);
    this.companyService.companygetxlsxreportApiCompanyIdGetxlsxreportPost(
      { id: this.commonService.currentCompany._id, body: xlsxParam }).subscribe((result: any) => {
        this.loaderService.display(false);
        if (result && result.length) {
          window.open(result, '_blank');
        } else {
          this.toast.sToast('error', result.msg);
        }
      });
  }

  drop(event: CdkDragDrop<string[]>): any {
    const displayedpreviousindex = this.displayedColumns.indexOf(this.columns[event.previousIndex].header);
    const displayedcurrentindex = this.displayedColumns.indexOf(this.columns[event.currentIndex].header);
    moveItemInArray(this.displayedColumns, displayedpreviousindex , displayedcurrentindex);
    moveItemInArray(this.columns, event.previousIndex , event.currentIndex);
    // const data = this.filterSource.filter((x: any) => x.value === this.filterKey)[0].data;
    // this.initiateTable(data);
    // setTimeout(() => { this.updateSubFilterTable({ value: this.filterSubKey }); });
  }

  showhide(i: any, list: any) {
    this.displayedColumns = [];
    this.columns.forEach(element => {
      if (element.header == list) {
        this.columns.filter((x) => x.header == list)[0].isvisible = !(this.columns.filter((x) => x.header == list)[0].isvisible);
        element.isvisible = this.columns.filter((x) => x.header == list)[0].isvisible;
      }
    });
    for (let columnsListindex = 0; columnsListindex < this.columnsList.length; columnsListindex++) {
      this.columns.forEach(element => {
        if (element.header == this.columnsList[columnsListindex] && element.isvisible == true) {
          this.displayedColumns.push(this.columnsList[columnsListindex]);
        }
      });   
    }
    console.log(this.displayedColumns);
    // const data = this.filterSource.filter((x: any) => x.value === this.filterKey)[0].data;
    // this.initiateTable(data);
    // setTimeout(() => { this.updateSubFilterTable({ value: this.filterSubKey }); });
  }
  actionCall(row: any, action: any): void {
    delete row.highlighted; delete row.hovered;
    const resp = { row, action };
    if (this.tableOptions.showAction && this.tableOptions.actionMenuItems.length > 0) {
      this.actionCallback.emit(resp);
    }
  }
}
